var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.textContent)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }